/*
 * default output formats for tesseract.js
 */

module.exports = {
  text: true,
  blocks: true,
  layoutBlocks: false,
  hocr: true,
  tsv: true,
  box: false,
  unlv: false,
  osd: false,
  pdf: false,
  imageColor: false,
  imageGrey: false,
  imageBinary: false,
  debug: false,
};
